/**
 * @brief Centralization of the application's plugin imports
 * @bug No known bugs.
 * @todo remove dexie idb
 * */

import Vue from 'vue'
import vuetify from './vuetify.js'
import './sapioConnector.js'
import './vuedraggable.js'
import './vue-notification.js'
import './vue-fullscreen.js'

const scenarioData = {
  shared: {
    scenario: {},
    team: '',
    team_id: '',
    game_id: '',
    api_key: '',
    score: 0,
    debug: false,
  },
}

Vue.prototype.$channel = null

export { vuetify, scenarioData }
